namespace advisorop.services {
    `use strict`;

    export class AccountGroupApi {

        readonly apiUrl = `/api/accountgroup`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }
        
        getAccounts(groupId: number, showClosedInactive: boolean): ng.IHttpPromise<any> {
            return this.$http.get(`${this.apiUrl}/${groupId}/accounts?showClosedInactive=${showClosedInactive}`);
        };

        getPerformanceDetails(groupId: number): ng.IHttpPromise<domains.IAccountGroup> {
            return this.$http.get(`${this.apiUrl}/${groupId}/performancedetails`);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service("accountGroupApi", AccountGroupApi);
}